import React from "react";

const HealthInformation=()=>{

    return(
        <>
        </>
    )
}

export default HealthInformation